<ng-container *transloco="let t; prefix: 'property-upload-wizard'">
  <div class="container flex flex-1 flex-col rfs:gap-28 items-center">
    <progress-stepper class="progress-stepper-onboarding" [StepNo]="3" [Steps]="Steps"></progress-stepper>
    <div class="container flex flex-col rfs:gap-28 items-center justify-between">
      <div class="flex flex-col gap-12 items-center justify-center">
        <div class="flex flex-col gap-4">
          <h2 class="h2 rfs:text-[40px] text-center font-semibold text-black">
            {{ t("headers.stepFour") }}
          </h2>
          <p class="rfs:text-xl text-center font-light">
            {{ t("infoText.stepFour") }}
          </p>
        </div>
      </div>
      <form class="w-full md:max-w-[800px]">
        <div class="flex w-full">
          <p class="md:pl-5 md:pb-10 pb-5 text-gray-950 font-semibold" for="Asking price">{{t("labels.askingPrice")}}
          </p>
        </div>
        <div class="flex w-full md:flex-row flex-col gap-6 items-center justify-center">
          <div class="flex md:max-w-[594px] w-full">
            <ngx-slider [(value)]="sliderValue" [options]="sliderOptions"
              (userChange)="onPriceSliderChange($event)"></ngx-slider>
          </div>
          <div class="flex md:max-w-[144px] md:self-center self-start">
            <fieldset class="flex gap-8">
              <div class="flex gap-3 items-center group/input">
                <div class="relative">
                  <span class="absolute inset-y-0 left-5 flex items-center pl-2 text-gray-700">€</span>
                  <input numericOnly #maxInput [value]="this.maxPriceValue" (change)="MaxPriceChanged(maxInput.value)"
                    (input)="MaxPriceInput(maxInput.value)" [placeholder]="maxPrice ? maxPrice.toLocaleString('de-DE') : minPrice.toLocaleString('de-DE')"
                    class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-12 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none" />
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </form>
    </div>
  </div>
  <app-property-upload-navigation [HidePrevious]="false" (NextButtonClicked)="saveStep()"
    (PreviousButtonClicked)="previousButtonClicked.emit()" [NextDisabled]="!maxPrice"></app-property-upload-navigation>
</ng-container>